import React, { useState, useEffect } from "react";
import { Input, Col, Row, Form, Checkbox, Select, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import RequestHandler from "../../util/RequestHandler";
import { odata } from "../Filters/Helper";
import { defaultValidateMessages } from "./Helper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const FirmAccountAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [bankDropdown, setbankDropdown] = useState([]);
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [bankBranchDropdown, setbankBranchDropdown] = useState([]);
  const [accountNumber, setAccountNumber] = useState("");
  const [iban, setIban] = useState("");
  const [form] = Form.useForm();

  useEffect(() => {
    RequestHandler.get(`/Bank?$filter=isEmoney ne true&$orderby=name`).then(res => {
      setbankDropdown(res.value.filter(x => x.id !== 999))
    });
  }, []);

  useEffect(() => {

    if (props.data?.accountNumber) {
      setAccountNumber(props.data?.accountNumber);
    }
    if (props.data?.iban) {
      setIban(props.data?.iban);
    }

    if (props.data?.firmId) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(`/Firm?$select=id,firmBranchNumber,name&$filter=id eq ${props.data.firmId}`).then(res => {
        setFirmSelect({ data: res.value, loading: false });
      });
    }

    if (props.data) {
      form.setFieldsValue(props.data);
    }

  }, [props.data]);

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(`/Firm?isFilter=true&$select=id,firmBranchNumber,name&$filter=${odata.contains("name", value)} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onBankChange = (value) => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${value}`).then(res => {
      setbankBranchDropdown(res);
    });
  }

  const onChangeIban = (value) => {
    setIban(value.target.value);
  }

  const onChangeAccountNumber = (value) => {
    setAccountNumber(value.target.value);
  }

  const onSuccess = () => {
    form.resetFields();

    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = values => {
    RequestHandler.post(`/FirmAccount`, values).then(response => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onFinishFailed = () => setLoading(false);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  const { Option } = Select;
  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="firmAccountAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>

        <Col span={24}>

          <Form.Item
            label="Cari Adı/Ünvanı"
            name="firmId"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              placeholder="En az 2 harf giriniz.."
              optionFilterProp="children"
              onSearch={onFirmSearch}
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={firmSelect.loading}
            >
              {firmSelect.data.map(item => (
                <Option key={item.id} value={item.id}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Banka"
            name="bankId"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              placeholder="Seçiniz."
              optionFilterProp="children"
              onChange={onBankChange}
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {bankDropdown.map(item => (<Option key={item.id} value={item.id}>{item.name}</Option>))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Iban"
            name="iban"
            onChange={onChangeIban}
            rules={accountNumber.length < 9 ? [{ required: true, },] : null}
          >
            <Input type="text" onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()} defaultValue="TR" maxLength="26" />
          </Form.Item>

          <Form.Item
            label="Banka Şubesi"
            name="bankBranchId"
            rules={iban.length < 20 ? [{ required: true },] : null}
          >
            <Select
              showSearch
              placeholder="Seçiniz"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {bankBranchDropdown.map(item => (
                <Option key={item.id}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Hesap Numarası"
            name="accountNumber"
            rules={iban.length < 20 ? [{ required: true }, { min: 7 }] : null}
          >
            <Input maxLength="17" onChange={onChangeAccountNumber} onInput={maxLengthCheck} />
          </Form.Item>

          <Form.Item
            label="Geçerli Hesap"
            name="isDefault"
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>

          <Col style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Ekle
            </Button>
          </Col>

        </Col>
      </Row>
    </Form>
  )
}
export default FirmAccountAddForm